/**
 * api接口的统一出口
 */
import BASE from "./base"; // 导入接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
const my = {
    // 我的挂牌列表
    applyList(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/list`, params);
    },
    // 林权挂牌申请保存
    saveForest(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/save/forest`, params);
    },
    // 土地挂牌申请保存
    saveRuralLand(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/save/ruralLand`, params);
    },
    // 林权挂牌申请提交
    forestSubmit(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/submit/forest`, params);
    },
    // 土地挂牌申请提交
    ruralLandSubmit(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/submit/ruralLand`, params);
    },
    //申请交易鉴证书
    certificate(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/certificate`, params);
    },
    //摘牌详情 /listing/apply/delisting/detail/{applyId}
    delistingDetail(params) {
        return axios.get(`${BASE.ZCT_API}/listing/apply/delisting/detail/${params.applyId}?type=${params.type}`, params);
    },
    // 挂牌详情  /listing/apply/detail/{applyId}
    applyDetail(params) {
        return axios.get(`${BASE.ZCT_API}/listing/apply/detail/${params.applyId}?type=${params.type}`, params);
    },
    // 申请中止审批  /listing/apply/pause/approve/{applyId}
    pauseApprove(params) {
        return axios.get(`${BASE.ZCT_API}/listing/apply/pause/approve/${params.id}`, params);
    },
    //获取流程所需要的文件
    getProcessFiles(params) {
        return axios.post(`${BASE.ZCT_API}/roleFileTypeConfig/getProcessFiles`, params);
    },
    //（林业、农村产权）摘牌、竞价
    operate(params) {
        return axios.post(`${BASE.ZCT_API}/delisting/operate`, params);
    },
    //（林业、农村产权）摘牌、竞价 通过银行卡号查询行号和开户行
    getBankCardByCardNo(params) {
        return axios.post(`${BASE.ZCT_API}/bankCard/getBankCardByCardNo`, params);
    },
    // 查询
    adminSignConfigGet(params) {
        return axios.get(`${BASE.ZCT_API}/admin/signConfig/get`, params);
    },
    // 我的竞价列表
    mypageAuctionlist(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/pageAuction`, params);
    },
    // 我的竞价支付
    payMyAuction(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/payMyAuction`, params);
    },
    // 支付服务费
    payTransactionAmount(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/payTransactionAmount`, params);
    },
    // 获取代缴代扣银行信息
    myInvestmentBankDetail(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/getDetail`, params);
    },
    // 我的资产列表
    pageMyAssetsList(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/pageMyAssets`, params);
    },
    // 我的投资列表
    myInvestmentlist(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/page`, params);
    },
    // 我的投资 获取余款
    getMyInvestmentDetail(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/getMyInvestmentDetail`, params);
    },
    // 我的投资 支付余款
    payMyInvestment(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/payMyInvestment`, params);
    },
    // 我的证书列表
    myCertificationList(params) {
        return axios.post(`${BASE.ZCT_API}/myCertification/page`, params);
    },
      //获取通知中心列表
    noticeList(params) {
        return axios.post(`${BASE.ZCT_API}/notificationCenter/getNotificationCenterList`, params);
    },
    //获取通知中心列表详情
    noticeDoneReadDetail(params) {
        return axios.post(`${BASE.ZCT_API}/notificationCenter/doneRead`, params );
    },
     //获取我的账户
    getTransactionList(params) {
        return axios.post(`${BASE.ZCT_API}/feeFlow/selectPage`, params);
    },
     //抵押公告
     mortgageAnnounceList(params) {
        return axios.post(`${BASE.ZCT_API}/mortgageNotice/queryMortgageNotices`, params);
    },
    //获取地区
    getAeraAndType(params) {
        return axios.post(`${BASE.ZCT_API}/projectNotice/getAeraAndType`, params );
    },
    //保证金重新支付
    repayPromiseMoney(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/repayPromiseMoney`, params );
    },
    //保证金重新支付---查询支付金额和银行卡号并校验是否可以代收代付
    repayPromiseRequest(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/getDetailByAmountId`, params );
    },
    // 竞价金额重新支付
    payMoney(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/payMoney`, params );
    },
    //根据区域和类型查询费项的相关信息
    getFeeItem(params) {
        return axios.post(`${BASE.ZCT_API}/admin/collectionFeeItem/getFeeItem`, params );
    },
    //我的投资重新支付 获取金额
    getRepayMoneyCount(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/getRepayMoneyCount`, params );
    },
    //通过挂牌id获取摘牌信息
    delistingGetDetail(params) {
        return axios.post(`${BASE.ZCT_API}/delisting/getDetail`, params );
    },
    //挂牌提交申请
    delistingMaterial(params) {
        return axios.post(`${BASE.ZCT_API}/delisting/material`, params );
    },
    //支付保证金
    payDeposit(params) {
        return axios.post(`${BASE.ZCT_API}/delisting/payDeposit`, params );
    },
    // 摘牌报价
    delistingOperate(params) {
        return axios.post(`${BASE.ZCT_API}/delisting/operate`, params );
    },
    // 查询交易规则配置详情 万鸿
    RuleDetail(params) {
        return axios.post(`${BASE.ZCT_API}/transactionRule/detail`, params );
    },
    // 竞价倒计时
    getTimeAmount(params) {
        return axios.get(`${BASE.ZCT_API}/listing/apply/delisting/timeAmount/${params.applyId}?type=${params.type}`, params);
    },
    // 申请摘牌时获取相关资料  小芳
    applyFile(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/file`, params );
    },
    // 底部信息  -万鸿
    websiteCopyright(params) {
        return axios.post(`${BASE.ZCT_API}/areaConfig/index/websiteCopyright`, params );
    },
    // 自定义信息保存 -小芳
    saveCustom(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/save/custom`, params );
    },
    // 自定义信息提交 -小芳
    submitCustom(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/submit/custom`, params );
    },
    //获取业务类型首页 -小芳
    getBusinessTypeInfo(params) {
        return axios.get(`${BASE.ZCT_API}/listing/apply/getBusinessTypeInfo`, params );
    },
    //获取代收代付银行卡列表 --陈壮鑫
    getBankInfo(params) {
        return axios.post(`${BASE.ZCT_API}/bankCard/getBankInfo`, params );
    },
    //我的投资详情-小芳
    investmentDetail(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/investmentDetail`, params );
    },
    //获取在线挂牌协议 -- 周鹏
    getAgreement(params) {
        return axios.post(`${BASE.ZCT_API}/listingAuthorizationAgreement/getAgreement`, params );
    },
    //增减挂钩保存 --小芳
    saveChangeLink(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/save/changeLink`, params );
    },
    //增减挂钩提交
    submitChangeLink(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/submit/changeLink`, params );
    },
    //增减挂钩获取模板
    getBidNoticeTemplate(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/getBidNoticeTemplate`, params );
    },
    //增减挂钩 申请竞买
    changeLinkOperate(params) {
        return axios.post(`${BASE.ZCT_API}/delisting/changeLinkOperate`, params );
    },
    //我的竞买列表
    pageBidding(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/pageBidding`, params );
    },
    //我的申请列表
    myApplyPage(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/applyPage`, params );
    },
    //我的竞买列表-详情
    biddingDetail(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/biddingDetail`, params );
    },
    // 我的竞买保存
    biddingSave(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/biddingSave`, params );
    },
    // 我的竞买提交
    biddingSubmit(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/biddingSubmit`, params );
    },
    // 我的投资获取确认书
    getConfirmFile(params) {
        return axios.post(`${BASE.ZCT_API}/myInvestment/getConfirmFile`, params );
    },
    //线下项目详情
    offlineProjectDetail(params) {
        return axios.post(`${BASE.ZCT_API}/offlineProject/detail`, params);
    },

};

export default my;
